import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyChQvzSHutRm1Jz6p0P-mFKm7r6NZaDK0c",
  authDomain: "haven-room-booking.firebaseapp.com", 
  projectId: "haven-room-booking",
  storageBucket: "haven-room-booking.appspot.com",
  messagingSenderId: "991584834215",
  appId: "1:991584834215:web:10691971a38991b4bd8182",
  measurementId: "G-PNY4KZ5BGV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with persistence
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting auth persistence:", error);
});

// Initialize Firestore
const db = getFirestore(app);

// Enable offline persistence
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.warn('The current browser doesn\'t support all of the features required to enable persistence');
  }
});

export { auth, db };
export default app;